// ReduxUser.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  EMPIMAGE: null,
  COMPANYLOGO: null,
  USERREFCODE: null,
  STOREDATE: null,
  COMPCODE: null,
  LOCCODE: null,
  RESTCODE: null,
  USERNAME: null,
  GROUPNAME: null,
  GROUPCODE: null,
  COMPNAME: null,
  RESTNAME: null,
  ADDRESS: null,
  SETUPDATE: null,
  BUSINESSTYPECODE: null,
  CATTYPE: null,
  ISCHAIN: null,
  LOCTIMEZONE: null,
  SYSDATE: null,
  TEMPKEY: null,
  TOKEN: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserParams: (state, action) => {
      console.log("Payload received:", action.payload);
      state.USER_PARAM = { ...action.payload };
      const randomLogo = "src/assets/images/shield2.png";
      state.COMPANYLOGO = action.payload.COMPANYLOGO || randomLogo;
      state.USERREFCODE = action.payload.USERREFCODE;
      state.TEMPKEY = action.payload.TEMPKEY || "";
    },
    resetUserParams: () => initialState,
    // setCodes: (state, action) => {
    //   const { COMPCODE, LOCCODE, RESTCODE } = action.payload;
    //   state.COMPCODE = COMPCODE;
    //   state.LOCCODE = LOCCODE;
    //   state.RESTCODE = RESTCODE;
    // },
  },
});

export const { setUserParams, resetUserParams } = userSlice.actions;

export default userSlice.reducer;
